export default __webpack_public_path__ + "static/media/pulseBg.be4b586b.png";